import React from 'react'

const Footer = () => {
  return (
    <footer>
        <p>Facu ©</p>
    </footer>
  )
}

export default Footer
